import { Typography, Flex, Button } from "antd"
import moment from "moment"

const { Text } = Typography

const getSortOrder = (sortKey, sortOrder, field) => {
  if (sortKey !== field) return null
  return sortOrder === "asc" ? "ascend" : "descend"
}

const getHeaders = (sortKey, sortOrder, onRowClick, t) => [
  {
    title: t("client.waivers.table.waiver_name"),
    dataIndex: "waiver_name",
    key: "waiver_name",
    sorter: true,
    sortOrder: getSortOrder(sortKey, sortOrder, "waiver_name"),
    render: (waiverName) => <Text strong>{waiverName}</Text>
  },
  {
    title: t("client.waivers.table.submission_for"),
    dataIndex: "submission_for",
    sorter: true,
    key: "submission_for",
    render: (submissionFor) => <Text>{submissionFor || t("client.waivers.table.no_value")}</Text>
  },
  {
    title: t("client.waivers.table.signed_on"),
    dataIndex: "signed_on",
    key: "signed_on",
    sorter: true,
    sortOrder: getSortOrder(sortKey, sortOrder, "signed_on"),
    render: (signedOn) => (
      <Text>{signedOn ? moment(signedOn, "MM/DD/YYYY").format("MMM DD, YYYY") : t("client.waivers.table.no_value")}</Text>
    )
  },
  {
    title: t("client.waivers.table.participants"),
    key: "participants",
    sorter: true,
    render: (_, record) => {
      const names = (record.participants || []).map((p) => p.full_name).filter(Boolean)
      if (!names.length) return <Text type="secondary">{t("client.waivers.table.no_value")}</Text>
      if (names.length <= 2) return <Text>{names.join(", ")}</Text>
      return (
        <Text>
          {names.slice(0, 2).join(", ")}{" "}
          <Text type="secondary">{t("client.waivers.table.more", { count: names.length - 2 })}</Text>
        </Text>
      )
    }
  },
  {
    title: t("client.waivers.table.pdf"),
    key: "pdf",
    render: (_, record) => {
      if (!record.signed_pdf_url) return <Text type="secondary">{t("client.waivers.table.no_value")}</Text>
      return (
        <Flex gap={8} onClick={(e) => e.stopPropagation()}>
          <Button size="small" onClick={() => onRowClick(record)}>{t("client.waivers.table.view")}</Button>
          <a href={record.signed_pdf_url} target="_blank" rel="noreferrer" download>
            <Button size="small">{t("client.waivers.table.download")}</Button>
          </a>
        </Flex>
      )
    }
  }
]

export { getHeaders }
